import { Badge, Text, WrapperFlex } from '@unimed-fesp/components';
import React, { useEffect, useState } from 'react';
import { ButtonContainer } from '../StatusList/styles';

const StatusFilter = ({ status, onStatusClick, activeStatus }) => {
  const [localActiveStatus, setLocalActiveStatus] = useState(activeStatus);
  useEffect(() => {
    setLocalActiveStatus(activeStatus);
  }, [activeStatus]);

  const availableStatus = status.filter(
    (currentStatus) => currentStatus.id !== localActiveStatus
  );

  const handleStatusClick = (currentStatus) => {
    if (localActiveStatus === currentStatus.id) {
      setLocalActiveStatus(null);
      onStatusClick(null);
    } else {
      setLocalActiveStatus(currentStatus.id);
      onStatusClick(currentStatus.id);
    }
  };

  return (
    <>
      <WrapperFlex marginTop={16} gap={5} justifyStart alignStart flexWrap>
        <Text text="Status Aplicado:" />
        {status.map(
          (status) =>
            localActiveStatus === status.id && (
              <ButtonContainer key={status.id}>
                <Badge
                  onClick={() => handleStatusClick(status)}
                  text={status.description}
                />
              </ButtonContainer>
            )
        )}
      </WrapperFlex>
      <WrapperFlex
        marginTop={16}
        marginBottom={16}
        gap={5}
        justifyStart
        alignStart
        flexWrap
      >
        {availableStatus.map((status) => (
          <ButtonContainer key={status.id}>
            <Badge
              onClick={() => handleStatusClick(status)}
              color={'#ababab'}
              cursorPointer
              text={status.description}
            />
          </ButtonContainer>
        ))}
      </WrapperFlex>
    </>
  );
};

export default StatusFilter;
